// extracted by css-extract-rspack-plugin
export default {"spinnerContainer":"_aa359098","mobileHeader":"_8469c35d","dropdown":"_6aa69a19"};